// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1mCi0","range":"MonthRangeSwitch_range__3OjnC","disabled":"MonthRangeSwitch_disabled__2aIGY"};